import { DialogObject } from '@/components/dialog/dialog.types';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { DynamicField, FieldVariant, SelectFieldProps, SelectOption, TextFieldProps } from '@/components/form-builder/form-builder.types';
import { DacRepository } from '@/store/dac-state/dac-state.repository';

interface getDacDownloadDialogProps {
  store: DacRepository;
  validate: () => void;
}

export const getDacDownloadDialog = ({ store, validate }: getDacDownloadDialogProps): DialogObject => {
  const downloadFormat: DynamicField<SelectFieldProps> = {
    label: 'Format',
    isRequired: true,
    variant: FieldVariant.SELECT,
    props: {
      placeholder: 'Choisissez le format',
      value: store.getNestedObservable('download', 'formatSelected'),
      options: [
        { name: 'PDF', code: 'pdf' },
        { name: 'DOCX', code: 'docx' },
      ],
      onSelectChange: (value: SelectOption) => {
        store.setNested('download', 'formatSelected', value);
      },
    },
  };

  return {
    title: 'Téléchargement',
    actions: [
      {
        label: 'Télécharger',
        variant: 'success',
        onClick: () => validate(),
      },
    ],
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject: {
          title: '',
          description: '',
          isHeaderHidden: true,
          class: '',
          grids: [
            {
              title: '',
              isHeaderHidden: true,
              gridItems: [
                {
                  fields: [downloadFormat],
                },
              ],
            },
          ],
        },
      },
    },
  };
};
